import { IMyOwnTractor } from '../../interfaces/OwnTractor.interfaces';
import { IPokeActionType } from '../../pages/MyInfo/MyInfoOwnTractorListPage/components/MyInfoUserOwnProductCard';
import { usePatchMyOwnTractorsMutation } from '../api/user/mutations/usePatchMyOwnTractors.mutation';

interface IUseTogglePokeStatusProps {
  tractor: IMyOwnTractor;
  onSuccess: IPokeActionType;
}

export const useTogglePokeStatus = ({ tractor, onSuccess }: IUseTogglePokeStatusProps) => {
  const { mutate: patchUsersOwnTractor } = usePatchMyOwnTractorsMutation();
  const handleButtonClick = () => {
    patchUsersOwnTractor(
      {
        ownTractorId: tractor.id,
        reqBody: {
          isPokeEnabled: !tractor.isPokeEnabled,
        },
      },
      {
        onSuccess: (data) => {
          onSuccess(tractor);
        },
      },
    );
  };

  return {
    handleTogglePokeStatus: handleButtonClick,
  };
};
